module.exports = __webpack_public_path__ + "img/icon-upcoming-meet-active.7c1a3680.svg";